import React, { PureComponent } from 'react';
// eslint-disable-next-line @repo/internal/react/no-class-components
export default class HtmlContent extends PureComponent {
  render() {
    const {
      html
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: html
      }
    });
  }
}